export default function loaderImg({ src }) {
  return src
}